export default __webpack_public_path__ + "static/media/27.c799f909.png";